export enum EProductCardType {
  Inventory = 'inventory',
  Market = 'market',
  Assortment = 'assortment',
}
